import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { BaseSnapshotProps, Snapshot } from "@custom-types/base-types";
import { useSnapshotMenuOptions } from "@pages/project-details/project-snapshots/hooks/use-snapshot-menu-options";

/**
 * 3-dot options menu for a snapshot row, providing contextual actions such as
 * open in sphere XG and open in HoloBuilder
 */
export function SnapshotOptionsMenu({
  snapshot,
}: BaseSnapshotProps): JSX.Element {
  const menuItems = useSnapshotMenuOptions();

  return <ListItemMenu<Snapshot> item={snapshot} menuItems={menuItems} />;
}
